import * as React from 'react';

import { fromJson } from '@bufbuild/protobuf';
import {
  TrailerEvent,
  TrailerEventSchema,
} from '@rematter/frontend-lib-api-client/grpc/transportation/v1/trailer_events_pb';
import { Col, EventDetailContainer, JsonViewer } from '@rematter/ui-web';

import { TrailerCreatedDetail } from './TrailerCreatedDetail';
import { TrailerDeletedDetail } from './TrailerDeletedDetail';
import { TrailerUpdatedDetail } from './TrailerUpdatedDetail';

type TrailerEventDetailProps = {
  payload: string;
};

export const TrailerEventDetail = ({ payload }: TrailerEventDetailProps) => {
  const [showJson, setShowJson] = React.useState(false);

  const event = React.useMemo((): TrailerEvent | null => {
    try {
      return fromJson(TrailerEventSchema, JSON.parse(payload));
    } catch {
      return null;
    }
  }, [payload]);

  if (!event) {
    return <JsonViewer data={payload} title="Raw Payload (Parse Error)" />;
  }

  const { event: inner } = event;

  const renderEventContent = () => {
    switch (inner.case) {
      case 'created':
        return <TrailerCreatedDetail event={inner.value} />;
      case 'updated':
        return <TrailerUpdatedDetail event={inner.value} />;
      case 'deleted':
        return <TrailerDeletedDetail event={inner.value} />;
      case undefined:
        return <JsonViewer data={payload} title="Unknown Event Type" />;
    }
  };

  const getEventTitle = (): string => {
    switch (inner.case) {
      case 'created':
        return 'Trailer Created';
      case 'updated':
        return 'Trailer Updated';
      case 'deleted':
        return 'Trailer Deleted';
      case undefined:
      default:
        return 'Unknown Event';
    }
  };

  return (
    <Col className="@TrailerEventDetail flex-1">
      <EventDetailContainer
        title={getEventTitle()}
        showJson={showJson}
        onToggleJson={() => setShowJson(!showJson)}
        jsonContent={payload}
      >
        {renderEventContent()}
      </EventDetailContainer>
    </Col>
  );
};
